import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

type UpdateAppointmentCustomerOwnerPayload = {
  appointment_id: number;
  user_id: number;
};

export const useUpdateAppointmentCustomerOwnerMutation = () =>
  useTypedMutation<UpdateAppointmentCustomerOwnerPayload, void>({
    mutationFn: async payload => {
      await ApiInstance.post("/appointments/update_customer_owner", payload);
    },
    onSuccess: ({ user_id }) => {
      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (!appointment) return;

      const customerOwner = typedQueryClient.getQueryData(AppointmentDetailsKeys.customerOwners(appointment.dealer_location_id))?.find(user => user.id === user_id);
      if (!customerOwner) return;

      typedQueryClient.setQueryData(AppointmentDetailsKeys.view, {
        ...appointment,
        customer_owner_name: `${customerOwner.first_name} ${customerOwner.last_name}`.trim(),
        customer_owner_profile_picture: customerOwner.profile_picture
      });
    }
  });
